<template>
  <div
    class="flex flex-col items-center mx-4 mt-3 px-2"
    id="small-receipt"
    :class="{
      'dir-ltr': $ctx.receiptLanguage == 'en',
      'dir-rtl': $ctx.receiptLanguage == 'ar'
    }"
  >
    <div class="flex flex-col items-center w-full" style="height: 100vh;">
      <!-- header info -->
      <div id="small-receipt-header" class="flex flex-col w-full">
        <div class="flex mt-6 justify-center w-full">
          <img :src="settingsStore.getValue('receipt_logo') ? settingsStore.storagePath + '/' + settingsStore.getValue('receipt_logo'): '@/assets/images/logo.svg'" :width="settingsStore.getValue('receipt_logo_width')" alt="" />
        </div>
      </div>

      <div id="small-receipt-body" class="w-full" style="color: black;">
        <!-- title -->
        <div class="flex flex-col w-full mt-2 items-center" style="color: black;">
          <h2 class="bg-gray-200 rounded py-1 px-2 font-bold mt-3 capitalize">
            {{ isQuote ? receiptTranslate("Quote", "receipt.quoteInvoice") : receiptTranslate("Sales Invoice", "receipt.salesInvoice") }}
          </h2>
        </div>

        <div :class="{'hidden': settingsStore.getValue('use_mini_sales_receipts_version') == 'true'}" class="flex flex-col items-center" style="color: black;">
          <div>
            <svg id="barcode" class="mt-3"></svg>
            <div class="flex items-center justify-center">
              <span class="font-bold mx-5" style="font-size: 20px;">{{
                barcodeText
              }}</span>
            </div>
          </div>
        </div>

        <div class="mx-5 mt-5 pb-2 text-sm self-end border-b border-black" style="color: black;">
          <p style="font-size: 12px;">
            {{ settingsStore.getValue('company_address') }}
          </p>
          <p :class="{'ltr-numbers': settingsStore.getValue('receipt_language') == 'ar'}">{{ settingsStore.getValue('company_phone1') + (settingsStore.getValue('company_phone2')? ` - ${settingsStore.getValue('company_phone2')}`: '') }}</p>
          <p>{{ settingsStore.getValue('company_email') }}</p>
          <p>{{ settingsStore.getValue('company_website') }}</p>
        </div>

        <div class="flex w-full px-5 justify-center mt-4" style="color: black;">
          <table class="order-info-table" :class="{ 'ar-receipt': $ctx.receiptLanguage == 'ar' }">
            <tr :class="{'hidden': settingsStore.getValue('use_mini_sales_receipts_version') == 'true'}">
              <td>
                <p>{{ receiptTranslate("Order Type", "receipt.orderType") }}</p>
              </td>
              <td>
                <p class="font-bold ">
                    <span v-if="order.orderType == 'direct'">{{
                        receiptTranslate("Direct", "receipt.orderTypes.direct")
                      }}</span>
                  <span v-if="order.orderType == 'pick_up'">{{
                      receiptTranslate("Pick Up", "receipt.orderTypes.pickup")
                    }}</span>
                  <span v-if="order.orderType == 'delivery'">{{
                      receiptTranslate("Delivery", "receipt.orderTypes.delivery")
                    }}</span>
                </p>
              </td>
            </tr>
            <tr :class="{'hidden': settingsStore.getValue('use_mini_sales_receipts_version') == 'true'}">
              <td>
                <p>{{ receiptTranslate("Payment Terms", "receipt.paymentTerms") }}</p>
              </td>
              <td>
                <p class="font-bold ">
                    <span v-if="order.invoice.paymentType == 'direct'">{{
                        receiptTranslate("Full", "receipt.invoiceTypes.full")
                      }}</span>
                  <span v-if="order.invoice.paymentType == 'credit_sale'">{{
                      receiptTranslate("On Account", "receipt.invoiceTypes.credit")
                    }}</span>
                  <span v-if="order.invoice.paymentType == 'layaway'">{{
                      receiptTranslate("Layaway", "receipt.invoiceTypes.layaway")
                    }}</span>
                  <span v-if="order.invoice.paymentType == 'cash_on_delivery'">{{
                      receiptTranslate("Cash on Delivery", "receipt.invoiceTypes.cashOnDelivery")
                    }}</span>
                </p>
              </td>
            </tr>
            <tr
              v-if="order.invoice.billDueDate"
              :class="{'hidden': settingsStore.getValue('use_mini_sales_receipts_version') == 'true'}"
            >
              <td>
                <p>{{ receiptTranslate("Due on", "receipt.dueOn") }}</p>
              </td>
              <td>
                <p class="font-bold ">{{ formatDate(order.invoice.billDueDate, 'DD/MM/YYYY') }}</p>
              </td>
            </tr>
            <tr :class="{'hidden': settingsStore.getValue('use_mini_sales_receipts_version') == 'true'}">
              <td>
                <p>
                  {{ receiptTranslate("Customer", "receipt.customer") }}
                </p>
              </td>
              <td>
                <p class="font-bold ">
                  {{
                    order.invoice.customer?.contactDisplayName
                      ? `${order.invoice.customer?.contactDisplayName} ${
                          order.invoice.customer?.businessName
                            ? " - " + order.invoice.customer?.businessName
                            : ""
                        }`
                      : receiptTranslate(
                          "Cash Customer",
                          "receipt.cashCustomer"
                        )
                  }}
                </p>
              </td>
            </tr>
            <tr v-if="order.invoice.customer && order.invoice.customer.phone && settingsStore.getValue('show_customer_phone_in_receipt') == 'true'">
              <td>
                <p>
                  {{ receiptTranslate("Phone", "receipt.phone") }}
                </p>
              </td>
              <td>
                <p class="font-bold mx-5">
                  {{
                    order.invoice.customer.phone + (order.invoice.customer.phone2 ? ` - ${order.invoice.customer.phone2}`: '')
                  }}
                </p>
              </td>
            </tr>
            <tr v-if="order.invoice.customer && order.invoice.customer.streetAddress && settingsStore.getValue('show_customer_address_in_receipt') == 'true'">
              <td>
                <p>
                  {{ receiptTranslate("Address", "receipt.address") }}
                </p>
              </td>
              <td>
                <p class="font-bold mx-5">
                  {{
                    order.invoice.customer.streetAddress
                  }}
                </p>
              </td>
            </tr>
            <tr v-if="isQuote">
              <td>
                <p>{{ receiptTranslate("Payment Terms", "receipt.paymentTerms") }}</p>
              </td>
              <td>
                <p class="font-bold">
                  <span v-if="order.invoice.paymentType == 'direct'">{{ receiptTranslate("Full", "receipt.invoiceTypes.full") }}</span>
                  <span v-if="order.invoice.paymentType == 'credit_sale'">{{ receiptTranslate("On Account", "receipt.invoiceTypes.credit") }}</span>
                  <span v-if="order.invoice.paymentType == 'layaway'">{{ receiptTranslate("Layaway", "receipt.invoiceTypes.layaway") }}</span>
                  <span v-if="order.invoice.paymentType == 'cash_on_delivery'">{{ receiptTranslate("Cash on Delivery", "receipt.invoiceTypes.cashOnDelivery") }}</span>
                </p>
              </td>
            </tr>
            <tr v-if="isQuote && order.validUntil">
              <td>
                <p>{{ receiptTranslate("Valid Until", "receipt.validUntil") }}</p>
              </td>
              <td>
                <p class="font-bold">{{ formatDate(order.validUntil, 'DD/MM/YYYY') }}</p>
              </td>
            </tr>
            <tr :class="{'hidden': settingsStore.getValue('use_mini_sales_receipts_version') == 'true'}">
              <td>
                <p>
                  {{ receiptTranslate("Location", "receipt.location") }}
                </p>
              </td>
              <td>
                <p v-if="$ctx.receiptLanguage == 'en'" class="font-bold ">
                  {{ order.location?.enName || "" }}
                </p>
                <p v-if="$ctx.receiptLanguage == 'ar'" class="font-bold ">
                  {{ order.location?.arName || "" }}
                </p>
              </td>
            </tr>
            <tr :class="{'hidden': settingsStore.getValue('use_mini_sales_receipts_version') == 'true'}">
              <td>
                <p>
                  {{ receiptTranslate("Order No", "receipt.orderNo") }}
                </p>
              </td>
              <td>
                <p class="font-bold ">{{ order.externalID }}</p>
              </td>
            </tr>
            <tr v-if="!isQuote && settingsStore.getValue('hide_cashier_name_in_receipt') != 'true'">
              <td>
                <p>
                  {{ receiptTranslate("Cashier", "receipt.cashier") }}
                </p>
              </td>
              <td>
                <p class="font-bold ">{{ order.user?.fullName }}</p>
              </td>
            </tr>
            <tr v-if="isQuote">
              <td>
                <p>
                  {{ receiptTranslate("Quoted By", "receipt.quotedBy") }}
                </p>
              </td>
              <td>
                <p class="font-bold ">{{ order.user?.fullName }}</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>
                  {{ receiptTranslate("Date & Time", "receipt.dateAndTime") }}
                </p>
              </td>
              <td>
                <p class="font-bold ">
                  {{ parseFormat(order.createdAt) }}
                </p>
              </td>
            </tr>
            <tr v-if="order.invoice.carrier?.name && settingsStore.getValue('show_carrier_info_on_receipt') == 'true'">
                <td>
                  <p class="flex gap-2 items-center">
                    {{ receiptTranslate("Carrier", "receipt.carrier") }}
                    <Icon icon="material-symbols:delivery-truck-speed-outline" :height="24"></Icon>
                  </p>
                </td>
                <td>
                  <p class="font-bold mx-5">
                    {{ order.invoice.carrier?.name }} {{ `${order.invoice.carrier?.phone ? '- ' + order.invoice.carrier?.phone: ''}` }}
                  </p>
                </td>
              </tr>
            <tr :class="{'hidden': settingsStore.getValue('use_mini_sales_receipts_version') == 'true'}">
              <td>
                <p>
                  {{ receiptTranslate("Order Notes", "receipt.orderNotes") }}
                </p>
              </td>
              <td>
                <p class="font-bold " dir="ltr">
                  {{ order.invoice.notes }}
                </p>
              </td>
            </tr>
          </table>
        </div>

        <div class="flex flex-col px-5 items-center" style="color: black;">
          <div
            v-if="order?.invoice.pouchID"
            class="flex flex-col w-full mt-2 items-center"
          >
            <h2 class="bg-gray-200 rounded py-1 px-2 flex">
              <span>{{ receiptTranslate("Pouch #", "receipt.pouch") }}</span>
              <span class="flex justify-end custom-bold mx-2">
                {{ order?.invoice.pouchID }}
              </span>
            </h2>
          </div>
        </div>

        <!-- items -->
        <div class="w-full px-5 my-2 text-sm" :class="{'hidden': settingsStore.getValue('use_mini_sales_receipts_version') == 'true'}">
          <table class="receipt-table w-full" :class="{ 'ar-receipt': $ctx.receiptLanguage == 'ar' }" style="color: black;">
            <thead>
              <tr class="text-sm">
                <th>
                  {{ receiptTranslate("Item Name", "receipt.itemName") }}
                </th>
                <th>{{ receiptTranslate("Qty", "receipt.qty") }}</th>
                <th>{{ receiptTranslate("Price", "receipt.price") }}</th>
                <th>
                  {{ receiptTranslate("Total", "receipt.total") }}
                </th>
              </tr>
            </thead>

            <tbody v-if="order.orderItems">
              <tr
                v-for="(oi, i) in returnedOrderItems(order)"
                :key="i"
                :class="{ 'receipt-row-border': !oi.item.isSerialized}"
            >
              <td class="reciept-cell line-through" style="line-height: 15px;">
                <div>
                  <span>{{ oi.item.receiptName ? oi.item.receiptName: oi.item.name }}</span>
                  <span v-if="oi.packInfo?.packID" class="mx-1">{{
                      ` - ${getPackName(oi)}, ${oi.packInfo.packQuantity} ${t('pcs')}`
                    }}</span>
                </div>
                <div v-if="oi.extraProperties?.batchNumber">
                  <span class="my-1 bg-gray-200 rounded-md px-1">{{ oi.extraProperties?.batchNumber }} - {{ oi.extraProperties?.expiryDate ? formatDate(oi.extraProperties?.expiryDate, 'DD-MM-YYYY') : '' }}</span>
                </div>
                <div v-if="oi.item.isSerialized && settingsStore.getValue('hide_serial_number_in_receipts') != 'true'" class="flex gap-2 flex-wrap">
                  <small v-for="ois in oi.orderItemSerials"
                         class="bg-gray-200 rounded-md px-1">{{
                      ois.itemSerial?.number
                    }}</small>
                </div>
                <small>{{ oi.notes }}</small>
              </td>

              <td>{{ oi.returnedQuantity }}</td>
              <td class="line-through">
                {{ formatDinero(oi.soldAtPriceDinero).replace("IQD", "") }}
              </td>
              <td class="line-through">{{ formatMoney(oi.itemSalePriceAmount * oi.returnedQuantity, "IQD").replace("IQD", "") }}</td>
            </tr>
              <tr
                v-for="(oi, i) in notReturnedOrderItems(order)"
                :key="i"
                class="text-sm"
                :class="{ 'receipt-row-border': !oi.item.isSerialized}"
              >
                <td class="text-sm reciept-cell">
                  <div>
                    <span>{{ oi.item.receiptName ? oi.item.receiptName: oi.item.name }}</span>
                    <span v-if="oi.packInfo?.packID" class="mx-1">{{ ` - ${getPackName(oi)}, ${oi.packInfo.packQuantity} ${t('pcs')}` }}</span>
                  </div>
                  <data v-if="oi.item.isSerialized && settingsStore.getValue('hide_serial_number_in_receipts') != 'true'" class="flex gap-2 flex-wrap">
                    <small v-for="ois in oi.orderItemSerials" class="bg-gray-200 rounded-md px-1">{{ ois.itemSerial?.number }}</small>
                  </data>
                  <small>{{ oi.notes }}</small>
                </td>

                <td>{{ oi.quantity - oi.returnedQuantity }}</td>
                <td>
                  <!-- Case 1: Item has discount - show (sold-at + discount) as strikethrough -->
                  <div v-if="oi.itemDiscountTotal && oi.itemDiscountTotal > 0" style="line-height: 15px;">
                    <div class="line-through">{{ formatMoney(oi.itemSalePriceAmount + oi.itemDiscountTotal, "IQD").replace("IQD", "") }}</div>
                    <div>{{ formatDinero(oi.soldAtPriceDinero).replace("IQD", "") }}</div>
                  </div>
                  <!-- Case 2: No discount but has dynamic pricing - show standard price as strikethrough -->
                  <div v-else-if="oi.itemSalePriceAmount !== oi.item.salePriceAmount && (oi.itemSalePriceAmount < oi.item.salePriceAmount)" style="line-height: 15px;">
                    <div class="line-through">{{ formatMoney(oi.item.salePriceAmount, "IQD").replace("IQD", "") }}</div>
                    <div>{{ formatDinero(oi.soldAtPriceDinero).replace("IQD", "") }}</div>
                  </div>
                  <!-- Case 3: No discount and no dynamic pricing - show normal price -->
                  <div v-else>
                    <div class="line-through" v-if="oi.soldAtPriceAmount < oi.item.salePriceAmount ">{{ formatMoney(oi.item.salePriceAmount, "IQD").replace("IQD", "") }}</div>
                    <div>{{ formatDinero(oi.soldAtPriceDinero).replace("IQD", "") }}</div>
                  </div>
                </td>
                <td>{{ formatMoney(oi.soldAtPriceAmount * (oi.quantity - oi.returnedQuantity), "IQD").replace("IQD", "") }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- payment info -->
        <div class="text-sm flex flex-col w-full" style="color: black;">
          <div class="flex-col">
            <div class="px-4 w-full mt-2">
              <table
                class="payment-table"
                :class="{ 'ar-receipt': $ctx.receiptLanguage == 'ar' }"
              >
                <tr>
                  <td>
                    <p class="p-0">
                      {{
                        receiptTranslate(
                          "Total Before Discounts",
                          "receipt.totalBeforeDiscounts"
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p class="text-right">
                      {{
                        formatMoney(calculateTotalBeforeDiscounts(), "IQD")
                      }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="p-0">
                      {{
                        receiptTranslate(
                          "Total Discount",
                          "receipt.totalDiscount"
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p class="text-right">
                      -{{ formatMoney((order.invoice?.totalDiscountAmount || 0) + calculateTotalItemDiscounts(), "IQD") }}
                    </p>
                  </td>
                </tr>

                <tr>
                  <td>
                    <p class="p-0">
                      {{ receiptTranslate("Customer Due", "receipt.customerDue") }}
                    </p>
                  </td>
                  <td>
                    <p class="text-right">
                      {{ formatDinero(order.invoice?.totalDueDinero) }}
                    </p>
                  </td>
                </tr>

                <tr v-if="order.invoice?.shippingFeeAmount">
                  <td class="flex items-center gap-1">
                    <p class="p-0">
                      {{
                        receiptTranslate(
                            "Shipping",
                            "receipt.totalShipping"
                        )
                      }}
                    </p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 640 512"><path fill="currentColor" d="M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16M160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48m320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48m80-208H416V144h44.1l99.9 99.9z"></path></svg>
                  </td>
                  <td>
                    <p class="text-right">
                      {{ formatDinero(order.invoice?.shippingFeeDinero) }}
                    </p>
                  </td>
                </tr>

                <tr>
                  <td>
                    <p class="p-0">
                      {{ receiptTranslate("Total Due", "receipt.totalDue") }}
                    </p>
                  </td>
                  <td>
                    <p class="text-right">
                      {{ formatMoney(order.invoice?.totalDueAmount + order.invoice?.insuranceTotalDueAmount, "IQD") }}
                    </p>
                  </td>
                </tr>

                <tr v-if="order.invoice?.insuranceID">
                  <td class="flex items-center gap-1">
                    <p class="p-0">
                      {{
                        receiptTranslate(
                            "Insurance",
                            "receipt.insurance"
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p class="text-right">
                      {{ formatDinero(order.invoice?.insuranceTotalDueDinero) }}
                    </p>
                  </td>
                </tr>

                <tr v-if="!orderHasPack(order)">
                  <td>
                    <p class="p-0">
                      {{
                        isQuote
                            ? receiptTranslate("Total Items", "receipt.totalItems")
                            : receiptTranslate("Total Items Sold", "receipt.totalItemsSold")
                      }}
                    </p>
                  </td>
                  <td>
                    <p class="text-right">
                      {{ calculateTotalItemsSold() }}
                    </p>
                  </td>
                </tr>
                <template v-else>
                  <tr>
                    <td>
                      <p class="p-0">
                        {{
                          receiptTranslate(
                              "Total Packs Sold",
                              "receipt.totalPacksSold"
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p class="text-right">
                        {{ calculateTotalPacksSold(order) }}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="p-0">
                        {{
                          receiptTranslate(
                              "Total Items Sold",
                              "receipt.totalItemsSold"
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p class="text-right">
                        {{ calculateTotalItemsSoldV2(order) }}
                      </p>
                    </td>
                  </tr>
                  <tr v-if="calculateTotalItemsReturnedV2(order) > 0">
                    <td>
                      <p class="p-0">
                        {{
                          receiptTranslate(
                              "Total Items Returned",
                              "receipt.totalItemsReturned"
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p class="text-right">
                        {{ calculateTotalItemsReturnedV2(order) }}
                      </p>
                    </td>
                  </tr>
                </template>
                <tr v-if="!orderHasPack(order) && calculateTotalItemsReturned() > 0">
                  <td>
                    <p class="p-0">
                      {{
                        receiptTranslate(
                            "Total Items Returned",
                            "receipt.totalItemsReturned"
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p class="text-right">
                      {{ calculateTotalItemsReturned() }}
                    </p>
                  </td>
                </tr>
              </table>
            </div>

            <div class="w-full p-2"></div>

            <div class="px-4 w-full mt-2" v-if="transactions.length" style="color: black;">
              <div style="color: black; padding-left: 2px">
                <h4 class="text-lg">
                  {{
                    receiptTranslate("Transactions Info", "receipt.transactionsInfo")
                  }}
                </h4>
              </div>

              <div
                v-for="customerPayment in transactions"
                :key="customerPayment.id"
              >
                <table
                  class="payment-table"
                  :class="{ 'ar-receipt': $ctx.receiptLanguage == 'ar' }"
                >
                  <tr>
                    <td>
                      <p class="p-0">
                        {{
                          receiptTranslate("Payment ID", "receipt.paymentID")
                        }}: {{ customerPayment.externalID }}
                      </p>
                    </td>
                    <td>
                      <p class="text-right">
                        {{ parseFormat(customerPayment.createdAt) }}
                      </p>
                    </td>
                  </tr>
                </table>

                <table
                  class="payment-table"
                  :class="{ 'ar-receipt': $ctx.receiptLanguage == 'ar' }"
                >
                  <tr v-if="customerPayment.receiptType != 'return'">
                    <td>
                      {{
                        receiptTranslate(
                          "Payment Method",
                          "receipt.paymentMethod"
                        )
                      }}
                    </td>
                    <td>
                      <p class="text-right">
                        {{ customerPayment.paymentMethod == "debit-card" ? `E-Payment${customerPayment.lastFourDigits ? ' (' + customerPayment.lastFourDigits + ')' : ''}` : '' }}
                        {{ customerPayment.paymentMethod == "cash" ? "Cash": '' }}
                        {{ customerPayment.paymentMethod == "credit" ? "Credit": '' }}
                      </p>
                    </td>
                  </tr>

                  <tr
                    v-if="
                      customerPayment.receiptType != 'return' && customerPayment.receiptType != 'refund' &&
                        customerPayment.paymentMethod === 'cash'
                    "
                    :class="{'hidden': settingsStore.getValue('use_mini_sales_receipts_version') == 'true'}"
                  >
                    <td>{{ receiptTranslate("Cash", "receipt.cash") }}</td>
                    <td>
                      <p v-if="customerPayment.paidBeforeChangeAmount > 0" class="text-right">
                        {{
                          formatDinero(customerPayment.paidBeforeChangeDinero)
                        }}
                      </p>
                      <p v-else class="text-right">
                        {{ formatDinero(customerPayment.amountDinero) }}
                      </p>
                    </td>
                  </tr>

                  <tr
                      v-if="
                      customerPayment.receiptType != 'return' && customerPayment.receiptType != 'refund' &&
                        customerPayment.paymentMethod === 'credit'
                    "
                  >
                    <td>{{ receiptTranslate("Credit", "receipt.customerCredit") }}</td>
                    <td>
                      <p v-if="customerPayment.paidBeforeChangeAmount > 0" class="text-right">
                        {{
                          formatDinero(customerPayment.paidBeforeChangeDinero)
                        }}
                      </p>
                      <p v-else class="text-right">
                        {{ formatDinero(customerPayment.amountDinero) }}
                      </p>
                    </td>
                  </tr>
                  
                  <tr
                      v-if="
                      customerPayment.receiptType == 'refund' &&
                        customerPayment.paymentMethod === 'cash'
                    "
                  >
                    <td>{{ receiptTranslate("Cash", "receipt.cash") }}</td>
                    <td>
                      <p class="text-right">
                        ({{ formatDinero(customerPayment.amountDinero)}})
                      </p>
                    </td>
                  </tr>

                  <tr
                    v-if="customerPayment.multiCurrencyBreakdown?.length === 2 && customerPayment.multiCurrencyBreakdown[1].amount > 0"
                  >
                    <td>
                      {{ receiptTranslate("Payment Currencies", "receipt.paymentCurrencies") }}
                    </td>
                    <td>
                      <p
                        class="text-right"
                      >
                        {{formatMoney(customerPayment.multiCurrencyBreakdown[0].amountBeforeChange, customerPayment.multiCurrencyBreakdown[0].currency)}} + {{formatMoney(customerPayment.multiCurrencyBreakdown[1].amountBeforeChange, customerPayment.multiCurrencyBreakdown[1].currency)}}
                      </p>
                    </td>
                  </tr>

                  <tr
                    v-if="
                      customerPayment.receiptType != 'return' && customerPayment.receiptType != 'refund' &&
                        customerPayment.paymentMethod === 'cash'
                    "
                    :class="{'hidden': settingsStore.getValue('use_mini_sales_receipts_version') == 'true'}"
                  >
                    <td>
                      {{ receiptTranslate("Change Due", "receipt.changeDue") }}
                    </td>
                    <td>
                      <p class="text-right">
                        {{ formatDinero(customerPayment.changeDueDinero) }}
                      </p>
                    </td>
                  </tr>
                  <tr v-if="customerPayment.receiptType != 'refund'">
                    <td>
                      {{ receiptTranslate("Total Paid", "receipt.totalPaid") }}
                    </td>
                    <td>
                      <p
                        v-if="customerPayment.receiptType != 'return'"
                        class="text-right"
                      >
                        {{ formatDinero(customerPayment.amountDinero) }}
                      </p>
                      <p
                        v-if="customerPayment.receiptType == 'return'"
                        class="text-right"
                      >
                        ({{ formatDinero(customerPayment.amountDinero) }})
                      </p>
                    </td>
                  </tr>
                  <tr v-if="customerPayment.receiptType != 'return' && customerPayment.receiptType != 'refund'">
                    <td>
                      {{ receiptTranslate("Balance", "receipt.balance") }}
                    </td>
                    <td>
                      <p class="text-right">
                        {{ formatDinero(customerPayment.balanceDinero) }}
                      </p>
                    </td>
                  </tr>
                  <tr v-if="customerPayment.receiptType != 'return'" :class="{'hidden': settingsStore.getValue('use_mini_sales_receipts_version') == 'true'}">
                    <td>
                      {{
                        receiptTranslate(
                          "Payment Notes",
                          "receipt.paymentNotes"
                        )
                      }}
                    </td>
                    <td>
                      <p class="text-right">
                        {{ customerPayment.description }}
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="small-receipt-footer"
        v-if="settingsStore.getValue('show_receipts_thecky_footer') == 'true'"
        class="flex justify-center self-center w-full mt-auto"
      >
        <div
          class="flex items-center justify-between py-2 px-4 mt-2 mb-4"
          style="bottom: 0px; width: 95%; border-top: 2px solid #BDC7D6"
        >
          <p><img src="@/assets/images/thecky-qr.png" style="height: 25px;"/></p>
          <p><img src="@/assets/images/footer.svg" style="height: 25px;"/></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

import {i18nOrderMessages, Order, OrderItem} from "@/models/sales/Order";
import { formatDate, parseFormat } from "@/utils/date";
import { useI18n } from "vue-i18n";
import { formatDinero, formatMoney } from "@/utils/money";
import { Transaction } from "@/models/accounting/Transaction";
import JsBarcode from "jsbarcode";
import {useSettingsStore} from "@/stores/settingsStore";
import { Icon } from '@iconify/vue'

export default defineComponent({
  components: {Icon},

  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          ...i18nOrderMessages.en
        },
        ar: {
          ...i18nOrderMessages.ar,
          receipt: {
            orderType: 'نوع الطلب',
            orderTypes: {
              direct: 'مباشر',
              delivery: 'توصيل',
              pickup: 'استلام من المحل',
              quote: 'تسعيرة',
              reservation: 'حجز',
            },
            paymentTerms: 'نوع الفاتورة',
            dueOn: 'تاريخ الاستحقاق',
            invoiceTypes: {
              full: 'كامل',
              credit: 'آجل',
              layaway: 'عربون',
              cashOnDelivery: 'دفع عند التوصيل',
            },
            salesInvoice: "فاتورة بيع",
            quoteInvoice: "عرض سعر",
            validUntil: "صالح حتى",
            totalItems: "عدد المنتجات",
            type: "نوع الطلب",
            direct: "مباشر",
            credit: "آجل",
            layaway: "عربون",
            customer: "الزبون",
            cashCustomer: "زبون",
            location: "المتجر",
            orderNo: "رقم الطلب",
            cashier: "موظف الكاشير",
            quotedBy: "بواسطة",
            dateAndTime: "التاريخ والوقت",
            carrier: "شركة التوصيل",
            orderNotes: "ملاحظات الطلب",
            pouch: "رقم المحفظة",
            itemName: "اسم المنتج",
            qty: "الكمية",
            price: "السعر",
            finalPrice: "السعر النهائي",
            totalBeforeDiscounts: "المبلغ الكلي قبل التخفيض",
            totalDiscount: "المبلغ الكلي للتخفيض",
            totalShipping: "التوصيل",
            totalDue: "الاجمالي",
            customerDue: "اجمالي الزبون",
            insurance: "شركة التأمين",
            totalItemsSold: "عدد المنتجات المباعة",
            totalItemsReturned: "عدد المنتجات المسترجعة",
            transactionsInfo: "الحركات المالية",
            paymentID: "رقم الحركة",
            paymentMethod: "طريقة الدفع",
            cash: "كاش",
            changeDue: "المتبقي",
            totalPaid: "المبلغ المدفوع الكلي",
            balance: "المتبقي",
            paymentNotes: "ملاحظات الحركة",
            phone: 'رقم الهاتف',
            address: 'العنوان',
            customerCredit: 'رصيد الزبون',
            total: 'المبلغ الكلي'
          }
        }
      }
    });

    const settingsStore = useSettingsStore();

    return { t, settingsStore, formatDate };
  },
  props: {
    order: {
      type: Order,
      required: true
    },
    transactions: {
      type: Array as PropType<Array<Transaction>>,
      required: true
    },
    barcodeText: {
      type: String,
      required: true
    },
    isQuote: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    setTimeout(() => {
      JsBarcode("#barcode", String(this.order.externalID!.slice()), {
        height: 50,
        displayValue: false
      });
    }, 100);
  },
  created() {
    // Add print CSS when component is created
    this.addPrintCSS();
  },
  beforeUnmount() {
    // Remove print CSS when component is about to be destroyed
    this.removePrintCSS();
  },
  methods: {
    parseFormat,
    formatDinero,
    formatMoney,
    print() {
      window.print();
    },
    calculateTotalItemsSold() {
      let total = 0;
      for (const item of this.order.orderItems) {
        total += item.quantity;
      }

      return total;
    },
    calculateTotalItemsReturned() {
      let total = 0;
      for (const item of this.order.orderItems) {
        total += item.returnedQuantity;
      }
      return total;
    },
    calculateTotalItemDiscounts() {
      let total = 0;
      for (const item of this.order.orderItems) {
        total += (item.itemDiscountTotal || 0) * item.quantity;
      }
      return total;
    },
    calculateTotalBeforeDiscounts() {
      // Total before discounts = Customer Total + Total Discount
      const customerTotal = this.order.invoice?.totalDueAmount || 0;
      const totalDiscount = (this.order.invoice?.totalDiscountAmount || 0) + this.calculateTotalItemDiscounts();
      return customerTotal + totalDiscount;
    },
    addPrintCSS() {
      // Create a style element with a unique id
      const style = document.createElement("style");
      style.setAttribute("id", "print-css");
      style.textContent = `
          @media print {
            @page:first {
              size: A4;
              margin-left: 0;
              margin-right: 0;
              margin-top: 0px;
            }
    
            @page {
              size: A4;
              margin-left: 0;
              margin-right: 0;
              margin-top: 40px;
              margin-bottom: 30px;
            }
          }`;
      // Append the style to the document head
      document.head.appendChild(style);
    },
    removePrintCSS() {
      // Find and remove the style element
      const style = document.querySelector("#print-css");
      if (style && style.parentNode) {
        style.parentNode.removeChild(style);
      }
    },
    receiptTranslate(value: string, translateKey: string): string {
      return this.$ctx.receiptLanguage == "en"
        ? value
        : this.t(translateKey, this.$ctx.receiptLanguage);
    },
    getPackName(oi: OrderItem) {
      for (const ip of oi.item.itemPacks) {
        if (ip.id == oi.packInfo.itemPackID) {
          return this.$ctx.locale == 'en' ? ip.pack?.enName: ip.pack?.arName
        }
      }
    },
    orderHasPack(order: Order) {
      let has = false;
      for (const oi of order.orderItems) {
        if (oi.packInfo?.packID) {
          has = true;
          break
        }
      }
      return has;
    },
    calculateTotalPacksSold(order: Order) {
      let total = 0;
      for (const oi of order.orderItems) {
        if (oi.packInfo?.packID) {
          total += oi.quantity;
        }
      }
      return total;
    },
    calculateTotalItemsSoldV2(order: Order) {
      let total = 0;
      for (const oi of order.orderItems) {
        if (oi.packInfo?.packID) {
          total += oi.quantity * oi.packInfo?.packQuantity;
        } else {
          total += oi.quantity;
        }
      }
      return total;
    },
    calculateTotalItemsReturnedV2(order: Order) {
      let total = 0;
      for (const oi of order.orderItems) {
        if (oi.packInfo?.packID) {
          total += oi.returnedQuantity * oi.packInfo?.packQuantity;
        } else {
          total += oi.returnedQuantity;
        }
      }
      return total;
    },
    returnedOrderItems(order: Order) {
        const returnedItems: OrderItem[] = []
        for (const oi of order.orderItems) {
          if (oi.returnedQuantity > 0) {
            returnedItems.push(oi)
          }
        }
        return returnedItems
      },
      notReturnedOrderItems(order: Order) {
        const noReturnedItems: OrderItem[] = []
        for (const oi of order.orderItems) {
          if (oi.quantity > oi.returnedQuantity) {
            noReturnedItems.push(oi)
          }
        }
        return noReturnedItems
      }
  }
});
</script>
<style>
.thecky-site {
  color: #000;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 3px;
}

#small-receipt {
  color: black;
  width: 80mm;
  overflow: scroll;
  background-color: #fff;
}
.small-account-statement-table table {
  table-layout: fixed;
  /* width: 200px; */
  border-collapse: collapse;
}

.small-account-statement-table tr:not(:last-child) {
  border-bottom: 1pt solid #bbbbbb;
}

.small-account-statement-table td {
  padding-top: 4px;
  padding-bottom: 2px;
  border-bottom: 1pt solid #bbbbbb;
}

.small-account-statement-table th,
td {
  width: auto;
  overflow: hidden;
}

.small-account-statement-table td:nth-child(1) {
  width: auto;
  min-width: 60px;
  overflow: hidden;
}

.small-account-statement-table td:nth-child(2) {
  width: auto;
  min-width: 130px;
  overflow: hidden;
}

.small-account-statement-table td:nth-child(3) {
  width: auto;
  min-width: 55px;
  overflow: hidden;
}

.small-account-statement-table td:nth-child(4) {
  width: auto;
  min-width: auto;
  overflow: hidden;
}

.header-table td:nth-child(1) {
  width: 120px;
}

.header-table td:nth-child(2) {
  width: 300px;
}

#small-receipt-header {
  margin-top: 10px;
}

#small-receipt-body {
  margin-top: 10px;
}

@media print {
  body * {
    page-break-after: avoid;
    visibility: hidden;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  #small-receipt,
  #small-receipt * {
    visibility: visible;
  }

  #small-receipt {
    color: black;
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: visible;
    margin: 0cm;
  }

  #small-receipt-header {
    margin-top: 0;
  }

  #small-receipt-body {
    position: relative;
  }

  p,
  div {
    page-break-inside: avoid;
  }
}
</style>
